import { render, staticRenderFns } from "./ClicCard.vue?vue&type=template&id=2a6539de&"
import script from "./ClicCard.vue?vue&type=script&lang=js&"
export * from "./ClicCard.vue?vue&type=script&lang=js&"
import style0 from "./ClicCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports